import React, { useContext } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import {
  forEach, get, isEmpty, join, keys, sortBy,
} from 'lodash';
import menuContext from '../../contexts/menu';
import PreOrder from '../../components/productDetailModal/PreOrder';
import useShoppingCart from '../../contexts/shoppingCart';
import { useSnackbarContext } from '../../contexts/menuToast';
import { OPTION_KEY_STRING_MAP } from '../../constants';

export default ({ data, onClose, isValid }) => {
  const {
    menuCache: { fridges: fridgesDict } = {},
  } = useContext(menuContext);
  const history = useHistory();
  const { showSnakbar } = useSnackbarContext();
  const { fridgeId } = useParams();
  const addItemToShoppingCart = useShoppingCart((state) => state.addItem);
  const {
    available,
    expireDay,
    name: productName,
    price,
    productNumber,
    redeemEndTime,
    redeemStartTime,
    sellPrice,
    options,
  } = data || {};
  const {
    [fridgeId]: {
      name: fridgeName,
      address: fridgeAddress,
    } = {},
  } = fridgesDict || {};

  const addItem = () => {
    const optionStrings = [];
    const { name } = data || {};

    forEach(sortBy(keys(options)), (key) => {
      const optionStringMap = get(OPTION_KEY_STRING_MAP, key);

      if (isEmpty(optionStringMap)) return;

      const optionString = get(optionStringMap, options[key]);

      if (isEmpty(optionString)) return;

      optionStrings.push(optionString);
    });

    const optionString = join(optionStrings, ',');

    addItemToShoppingCart({
      ...data,
      ...(options && { options }),
      ...(optionString && { name: `${name}(${optionString})` }),
    });
  };

  const onAddToCartButtonClick = () => {
    if (isValid && !isValid()) return;

    addItem();

    showSnakbar(
      <>
        成功加入餐籃，
        <NavLink to="/menu/shopping-cart" style={{ textDecoration: 'underline' }}> 前往餐籃 </NavLink>
        。
      </>
    );

    onClose();
  };

  const onCheckoutButtonClick = async () => {
    if (isValid && !isValid()) return;

    addItem();

    onClose();

    history.push('/menu/shopping-cart', {
      selectedItems: [{ ...data }],
    });
  };

  return (
    <PreOrder
      available={available || 1}
      expireDay={expireDay || 1}
      fridgeAddress={fridgeAddress || ''}
      fridgeName={fridgeName || ''}
      inventory={3}
      onAddToCartButtonClick={onAddToCartButtonClick}
      onCheckoutButtonClick={onCheckoutButtonClick}
      price={price || 0}
      productName={productName}
      productNumber={productNumber}
      redeemEndTime={redeemEndTime || 0}
      redeemStartTime={redeemStartTime || 0}
      sellPrice={sellPrice || 0}
    />
  );
};
